import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './SearchBar.module.less';
import { UsersSelectors } from '../../Redux/modules/users/selectors';
import { AppSelectors } from '../../Redux/modules/app/selectors';

const SearchBanner = (props) => {
  const subscriptionEndDate = props.usersData?.search_status?.end_date; //eslint-disable-line
  const today = moment();
  const endDate = moment(subscriptionEndDate, 'YYYY-MM-DD');
  const getMessage = (daysLeft) => {
    if (daysLeft < 2) {
      return gettext(`Your trial ends in the next ${(daysLeft + 1) * 24} hours`);
    }
    if (daysLeft === 2) {
      return gettext(`Your trial ends in the next 48 hours`);
    }
    return `${gettext('There are')} ${daysLeft} ${gettext('days remaining in your trial')}`;
  };
  const daysLeft = Math.floor(endDate.diff(today, 'days', true) + 1);
  if (props.isShowing) {
    return (
      <div className="">
        <div className={styles.bannerBg}>
          <div className={styles.bannerContent}>
            <div className={styles.text}>{getMessage(daysLeft)}</div>
            {props.isAdmin ? (
              <div>
                <a href="/contact-us/" role="button" target="_blank" tabIndex={0} className={styles.link}>
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  {gettext('Contact Sales')}
                </a>
              </div>
            ) : (
              <span className={styles.text} style={{ fontWeight: 300 }}>
                {gettext('Please contact your administrator')}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

SearchBanner.propTypes = {
  isShowing: PropTypes.bool,
  usersData: PropTypes.object,
  isAdmin: PropTypes.bool,
};
const mapStateToProps = (state) => {
  return {
    usersData: UsersSelectors.usersDataSelector(state),
    isAdmin: AppSelectors.isOrgAdminSelector(state),
  };
};

export default connect(mapStateToProps, null)(SearchBanner);
